import { Col, DatePicker, Form, Input, Row, Switch, TimePicker } from 'antd'
import {
  useDeleteScheduledMessage,
  useGetScheduleMessageById,
} from 'api/Contact/Contact'
import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React, { useEffect, useState } from 'react'
import { eventShatStore } from 'state/event/eventChat'
import RecepientInput from './ModalContnet/RecepientInput'
import { EventResp } from 'types/event/events'
import Spinner from 'components/Spinner'
import moment from 'moment'
import ShowScheduleContent from './ModalContnet/ShowScheduleContent'
import CustomModalFooter from 'components/global/CustomModalFooter'
import AlertModal from 'helper/AlertModal'

interface ShowScheduleDetailProps {
  eventData: EventResp
}

const ShowScheduleDetail: React.FC<ShowScheduleDetailProps> = ({
  eventData,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const { scheduleModalVisible, setScheduleModalVisible, scheduleForId } =
    eventShatStore(store => ({
      scheduleModalVisible: store.scheduleModalVisible,
      setScheduleModalVisible: store.setScheduleModalVisible,
      scheduleForId: store.scheduleForId,
    }))
  const { mutate: deleteScheduledMessage, isLoading: deleteMutationLoading } =
    useDeleteScheduledMessage()

  const onYesClick = () => {
    deleteScheduledMessage(scheduleForId, {
      onSuccess: () => {
        setScheduleModalVisible(false)
      },
    })
  }

  const handleDelete = () => {
    setAlertModal(true)
  }

  return (
    <>
      <CustomModal
        openModal={scheduleModalVisible}
        closeModal={setScheduleModalVisible}
        title="Schedule"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-end"
            btnText="Delete,Update"
            onSubmit={handleSubmit}
            closeModal={handleDelete}
          />
        }
      >
        <ShowScheduleContent form={form} eventData={eventData} />
      </CustomModal>

      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={{
            name: 'Delete Schedule',
            message1: `Are you sure you want to delete the schedule?`,
          }}
          onYesClick={onYesClick}
          loading={deleteMutationLoading}
        />
      )}
    </>
  )
}

export default ShowScheduleDetail
